import { ChipType } from '../types';
import { CHIP_300_BLUE, chipsMIN200 } from './chipsValues';

export const CHIPS_MIN_300: ChipType[] = [CHIP_300_BLUE, ...chipsMIN200];
